// contract-channel
import {
  axios
} from '../index'

export {
  axios as contract
}

let scope = 'contract'

// 产生api方法
// function axiosFactory(url, params) {
//   return axios.post(
//     `${scope}${url}`, params
//     )
// }

export default {
  // 合同接口
  contract: {
    // 获取合同详情
    getContractDetailsById(contractId) {
      return axios.get(`/${scope}/getContractDetailsById/${contractId}`)
    },
    // hhpp 106 获取末月加信息
    getEndAddition(contractId) {
      return axios.get(`/${scope}/discount/endAddition/has/${contractId}`)
    },
    getContractDetailsAndMouthLastPlusById(contractId) {
      return axios.get(`/${scope}/getContractDetailsAndMouthLastPlusById/${contractId}`)
    },
    getDelegateContractBill(params) {
      return axios.post(`/${scope}/getDelegateContract/financial`, params)
    },
    getContractInfo(params) {
      return axios.post(`/${scope}/list`, params)
    },
    // 根据起租时间和租期时长 获取退租时间
    getContractEndTime(params) {
      return axios.post(`/${scope}/getContractEndTime`, params)
    },
    // 末月加 + 退租时间是否超过房东合同到期日
    getLastMonthPlusEndTime(params) {
      return axios.post(`/${scope}/check/contract/end/time`, params);
    },
    // 获取 合同租期时长
    getContractTime(houseSpaceId, signType) {
      return axios.get(
        `/${scope}/get/contract/time/slot/${houseSpaceId}/${signType}`
      )
    },
    // 根据房源ID 获取生效的合同信息
    getEffectContractInform(id) {
      return axios.get(`/${scope}/get/effect/userId/byHouseId/${id}`)
    },
    setBusinessContract: params =>
      axios.post(`/${scope}/addEnterpriseContract`, params),
    // 将普通图片转为 证件图片
    transformPhoto: addrList =>
      axios.post(`/${scope}/attachment/changeAttachmentStatus`, addrList),
    // 获取费用信息
    getEnergyInform: contractId => axios.get(`${scope}/get/energy/config/${contractId}`),
    // 房东合同导出
    exportDelegateExcel: params =>
      axios.post(`${scope}/excel/exportDelegateExcel`, params, {
        responseType: 'blob'
      }),
    // 房东账单导出
    exportLandlordOrder: params =>
      axios.post(`${scope}/excel/exportLandlordOrder`, params, {
        responseType: 'blob'
      }),
    // 创建合同
    addContract: params =>
      axios.post(
        `/${scope}/simplyAddContract`,
        params
      ),
    // 查询合同是否有末月加
    queryLastMonth(id) {
     return axios.get(`/${scope}/discount/controllerJionEndAdding/${id}`)
    },
    // 手动录入末月加优惠券
    addLastMonth: params => axios.post(`${scope}/discount/endAdding/entry`, params),
    // 查询 选中末月加续租的时候的pdf 租期时长
    endAddition(contractId) {
      return axios.get(`/${scope}/discount/endAddition/query/${contractId}`)
    },
    // 查询房源是否在末月加有效期
    isLastMonthPlusByHouseSpaceId(contractId) {
      return axios.get(`/house/isLastMonthPlusByHouseSpaceId/${contractId}`)
    },
    // 查询 选中末月加续租的时候的pdf 租期时长
    endAddingAndFile(contractId) {
      return axios.get(`/${scope}/discount/endAddingAndFile/query/${contractId}`)
    },
  },
}



// WEBPACK FOOTER //
// ./src/xhr/services/contract.js